import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { client } from './utils/api';

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <HashRouter basename="/">
        <App />
      </HashRouter>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
